import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import { Check } from "@/icons";

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { className, ...props },
  ref,
) {
  return (
    <span className="relative inline-flex">
      <input
        ref={ref}
        type="checkbox"
        className={cn(
          // Unchecked: lift the fill to surface-2 and use the strong border so
          // the box stays visible on dark cards — `--input` equals `--surface`
          // (#171a1c) in dark mode, so border-border + bg-input would vanish
          // into any surface-level dialog/card background.
          "peer h-5 w-5 shrink-0 cursor-pointer appearance-none rounded-md border border-border-strong bg-surface-2 transition-colors",
          "checked:border-primary checked:bg-primary",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/55",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...props}
      />
      <Check
        strokeWidth={3}
        className="pointer-events-none absolute left-0.5 top-0.5 h-4 w-4 text-primary-fg opacity-0 transition-opacity peer-checked:opacity-100"
      />
    </span>
  );
});
